const ja_JP :{[key: string]: string} = {
    login:'登録',
    email:'E-メール',
    cachierDesk:'レジ',
    password:'暗証番号',
    userNameNotNull: 'E-メールが空けてはなりません',
    passwrodNotNull: '暗証番号が空けてはなりません',
    historyReport:'統計歴史',
    setting:'設定',
    collectMoney:'レジにします',
    amtNotNull: '金額が空けてはなりません',
    amtShouldBeNum:'金額は数字しなければなりません',
    amtGreaterThan0:'金額は0より大きくなければなりません',
    amtShouldBeInteger: '金額は小数点がありません',
    amt: '金額',
    remark:'チップ',
    genQr:'QRコードを作成します',
    scanQr:'QRコードをスキャンします',
    collectQr:'QRコード決済',
    paySucc: '支払成功',
    unpaid: '未支払',
    modifyPass: '暗証番号を修正します',
    passLengthError: '暗証番号の長さは６位以上になります',
    passConfirmError: '２つの暗証番号は一致しません',
    oldPass:'元暗証番号',
    newPass: '新暗証番号',
    confirmPass:'暗証番号を確認します',
    confirmModify: '修正を確認します',
    transSucc: '支払成功',
    newOrder:'新しい注文',
    orderNo:'注文番号',
    buyer: '支払方',
    payTime: '支払時間',
    finish: '完成',
    scanQrTips:'QRコードを枠にして、自動的にスキャンできます',
    lightOn: 'ライトをオンします',
    lightOff: 'ライトをオフします',
    logout:'ロッグアウト',
    confirmLogoutMsg:'現在のアカウントを六グアウトしますか？',
    cancel: 'キャンセル',
    confirm:'確認',
    languages: '言語',
    refunded:'払い戻しました',
    transFailed:'取引を失敗しました',
    refunding: '正払い戻す中',
    refund: '払い戻す',
    refundAmtLimit_1: '払い戻す金額は',
    refundAmtLimit_2:'超えてはいけません',
    canRefundAmt:'払い戻す可能な金額',
    refundAll:'完全に払い戻します',
    refundAmt:'払い戻す金額',
    report: 'レポート',
    dayReport:'毎日の取引概要',
    overview:'概要',
    transNum:'取引回数',
    fee: '手数料',
    payment: '決済',
    orderDetail: '注文詳細な情報',
    status:'状態',
    transactions:'取引',
    noData:'データなし',
    noMore:'もっと情報はない',
    storeName:'店舗名',
    employeeName:'スタッフ名前',
    employeeTitle:'スタッフ職務',
    currency: '決済貨幣',
    basicInfo:'基本情報',
    keyError:'キーエラー',
    modifySucc:'修正成功！',
    refundSucc: '払い戻し成功！',
    SYSTEM_ERROR:'システムは忙しくて、後でお試してください',
    NETWORK_ERR: 'ネットエラー',
    chooseLan:'言語を選択',
    dealing:'処理中',
    transFailTips: '取引失敗、改めてお試してください',
    /////////2018.10.10///////////
    forgetPassword: 'パスワードを忘れた?',
    contactUs: 'お問い合わせ',
    contactTips: 'ご連絡するために、メールアドレスをください。',
    submit: '送信する',
    contactSuccTips:'送信成功しました。早めにご連絡いたします。',
    expireTime:'無効時間:',
    home: 'ホーム',
    bills: '請求書',
    my: '本人',
    partialRefunded: '部分払戻し',
    returnLogin: 'ログインに戻す',
    saveSucc: '保存成功',
    todayIncome: '本日の取引金額',
    todayTrans: '本日の取引数量',
    queryOrder:'注文履歴',
    cameraNotAuthorzied: 'カメラが許可されていないので、設定中に権限を開いてください。',
    camerarollDenied: 'アルバムアクセス権限は許可されていないので、設定中に開いてください。',
    queryOrderTips: '注文番号を入力したり、注文書をスキャンしてください。',
    loading: 'ローディング...',
    oldPasswrodNotNull: '元暗証番号が空けてはなりません',
    newPasswrodNotNull: '新暗証番号が空けてはなりません',
    orderNoNotNull: '注文番号が空けてはなりません',

    //======
    confirmPasswrodNotNull: '暗証番号を確認しますが空けてはなりません',
    emailNotNull: 'E-メールが空けてはなりません',
    //=====2018.11.14====
    employeeManage: 'スタッフの管理',
    SUPER_ADMIN: '最高管理者',
    ADMIN: '店舗管理者',
    CASHIER: 'キャッシャー',
    modifyUser: 'スタッフの情報を修正',
    loginNo: '登録アカウント',
    name: '名前',
    phoneNumber: '携帯番号',
    role: 'キャラクター',
    newUser: 'スタッフ追加',
    add: '追加',
    userBuyFee: 'ユーザーは手数料を負担します',
    userBuyFee_checkout: 'ユーザーは負担する手数料',
    delete: '削除',
    pleaseInput: '入力',
    pleaseSelect: '選択する',
    settlement: '決済センター',
    allDate: '全ての日付',
    settlementAmt:'決済金額',
    merchantQr:'加盟店側のQRコード',
    clickView: 'チェック',
    Alipay: 'Alipay',
    Wechat: 'Wechat',
    collectAmt: '入金金額',
    collectNum: '受取る件数',
    refundNum: '払戻す件数',
    orderList:'注文リスト',
    settlementDetail: '決済の詳細',
    current: '現在',
    //======
    scanBarcode: '掃描條碼',
    photos: 'アルバル',
    noQR: 'QRコード/バーコードには認識されていません。',
    deleteSucc: '削除成功！',
    emailNoValid: 'メール形式が不正です',
    passwordLessThan6:'暗証番号は少なくとも6桁',
    //========
    settled: '決済済み',
    unSettled: '未決済',
    iSee: '了解です！',
    unSettledTips: '決済金額はまだ手数料が引かれていませんので、手数料は小数点の処理に関連し、実際の決済に準拠する必要があります。',
    voiceTip: '受取の音声放送',
    //=====
    exchangeRate: '為替レート',
    payCurrency: '取引通貨',
    markupRate: '為替レートが上がる',
    modifyRate: '為替レートの上昇率を修正',
    confirmDeleteMsg:'このユーザーを削除してよろしいですか？',
    company: '企業名',
    contactPerson: '連絡先',
    //=====
    storeNotNull: '店舗を選ばなければなりません。',
    allStore:'全部店舗',
    turnOverLineTitle:'売上日トレンド（1週間）',
    merchantStatsTitle: '店の本日の売り上げ',
    turnover: '売上高',
    storeManagement: '店鋪の管理',

    // ========
    collapse: '折りたたむ',
    connected: 'オンライン',
    disconnected: 'オンライン',
    monthlyIncome: '今月の収入額',
    monthlyTradeNum: '今月のトランザクション数',
    collecting: 'あなたはお金を集めています:',
    scanOrEnterPayQr: '支払いQRコードをスキャンまたは入力してください',
    latestOrders: '最新の注文',
    more: 'もっと見る',
    cancelled: 'キャンセル済み',
    selectDate: '日付を選択',
    startDate: '開始日',
    endDate: '終了日',
    settlementStatus: '決済状況',
    all: '全部',
    payType: '支払方法',
    query: '問い合わせ',
    export: 'エクスポートファイル',
    clear: 'クリア',
    unknown: '不明',
    pagiPrefix: ' ',
    pagiAfter: '件を表示',
    settlementList: '決済履歴',
    settlementDate: '決済日',
    operations: '操作',
    downloadDetail: 'ダウンロードの詳細',
    merchantInfo: 'ビジネス情報',
    country: '国/地域',
    storeType: '店舗タイプ',
    SINGLE: 'シングルストア',
    CHAIN_STORE: 'チェーン店',
    paymentSettings: '支払い設定',
    modify: '変更する',
    download: 'ダウンロードする',
    emialNotCorrect: 'メールボックスの形式が正しくありません',
    nameNotNull: '名前は空にできません',
    phoneNotCorrect: '電話番号が間違っています',
    lastLogin: '最終着陸時刻',
    deleteUser: 'ユーザーを削除',
    developerInfo: '開発者情報',
    merchantName: '加盟店名',
    merchantNo: '加盟店番号',
    view: '表示する',
    storeInfo: '店舗情報',
    storeId: '店舗番号',
    interfaces: '利用可能なAPI',
    online: 'オンライン',
    offline: '実店舗',
    webpage_api: 'Web Page API',
    app_api: 'App API',
    barcode_api: 'Barcode API',
    transqr_api: 'Transaction qrcode API',
    jsapi_api: 'JS API',
    dashboard: 'ダッシュボード',
    orders: '注文管理',
    settlements: '決済管理',
    merchant: '加盟店管理',
    info: '基本情報',
    users: 'スタッフの管理',
    account:'アカウント情報',
    developer: '開発者',
    mustBeNumer:'数字でなければなりません',
    modifyPassSucc: '変更が成功しました。新しいパスワードでログインしてください。',
    addUserSucc: 'ユーザーの成功を追加！',
    newOrderNoitf: '新しい注文、取引金額があります:',
    unpaidToast: 'ユーザーの支払いを待って、ユーザーが支払いを完了したかどうかを確認してください',
    queryOrderManually: '注文を手動でクエリする',
    manualQueryOrderTips:'説明：注文番号を入力またはスキャンして、注文のステータスを手動で照会します。 この機能は、ユーザーが支払いをしたが、管理ステーションがメッセージを受信していないときに使用できます。',
    findPassword: 'パスワードを取得する',
    findPasswordTips: 'ログインアカウントに入力してください。パスワードを取得するためのメールを送信し、メールのプロンプトに従ってパスワードを取得します。',
    send: '送る',
    backToLogin:'ログインに戻る',
    resetPassword: 'パスワードをリセット',
    resetPasswordTips: 'パスワードを回復しています。メールアドレスと新しいパスワードを入力してください',
    sendSucc: '正常に送信されました。メールを確認してください！',
    resetSucc: 'リセットに成功しました。新しいパスワードを使用してログインしてください！',
    reSendText: '{second}秒後に再送信',
    msg404: '申し訳ありませんが、探していたページは消えました',
    //====
    balance: '口座残高',
    unsettled: '未決済金額',
    minimum: '最低現金引き出し金額',
    withdrawal: '現金引き出し可能金額',
    cash: '現金で出す',
    bank: '現金引き出し銀行',
    accountNumber: '銀行口座',
    accountName: '銀行口座名',
    money: '現金引き出し',
    cashToast: '現金引き出し金額は最低現金引き出し金額に等しく、以下は現金引き出し可能金額に等しくなければなりません。',
    collection: '入金管理',
	collectionLink: '入金リンク',
    createLink: 'リンクを生成',
    storeChoose: '店舗選択',
    searchLink: 'リンクを検索',
    copy: 'コピー',
    copySuccess: 'コピー成功',
    copyError: 'コピーに失敗しました。手動でコピーしてください',
	transactionStatus: '取引の状態',
	paid: '支払い済み',
	linkList: 'リンクリスト',
    createTime: '作成時間',
    payNo: '支払い注文番号',
    partnerNo: 'パートナー注文番号',
    linkDetail: 'リンクの詳細',
	exchangeManage: '為替交換管理',
	exchangeApply: '為替交換の申し込み',
	exchangeRecords: '為替交換記録',
	canExchangeAmount: '為替交換可能金額',
	salesAmount: '為替レート',
	buyingCurrency: '貨幣を買い入れる',
	defaultBank: 'デフォルトの銀行口座を使うかどうか',
	yes: 'はい、',
	no: 'いいえ、',
	bankName: '銀行の名前',
	bankNumber: '銀行口座',
	bankAccName: '銀行口座名',
	bankAddress: '銀行の住所',
	swiftcode: '銀行Swiftcode',
	exchangeDetail: '為替交換の詳細',
	currentCurrency: '通貨を売り渡す',
	purchaseAmount: '購入金額',
	availableBalance: '利用可能残高',
	improveBankInformation: '銀行情報を完備してください。！',
	sellToast: '販売金額を入力してください。',
	currencyToast: '貨幣を選んでください！',
	successTime: '成功時間',
	exchangeSucc: '成功',
	untreated: '未処理',
	functionToast: 'この機能はまだ開通していません。！'
}

export default ja_JP